import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import toast from 'react-hot-toast';
import i18n from 'i18n';

const RATE_LIMIT_TOAST_ID = 'rate-limit-error';

const handleThrottledAction: ReturnType<Middleware<{}, unknown>> = (next) => (action) => {
  if (isRejectedWithValue(action) && (action.payload as FetchBaseQueryError)?.status === 429) {
    const meta = (action.meta as { baseQueryMeta?: { response?: Response } })?.baseQueryMeta;
    const retryAfterSeconds = Number(meta?.response?.headers.get('Retry-After'));

    toast.error(
      retryAfterSeconds > 0
        ? i18n.t('common.error.too.many.requests', { seconds: retryAfterSeconds })
        : i18n.t('common.error.too.many.requests.generic'),
      { id: RATE_LIMIT_TOAST_ID },
    );
  }

  return next(action);
};

export const throttleMiddleware: Middleware<{}, unknown> = () => handleThrottledAction;
